import { ADD_FLASH_MESSAGE, REMOVE_FLASH_MESSAGE } from 'actions/actionTypes';
import { FlashMessageActionTypes, FlashMessageState } from 'types/flashMessage';

const initialState: FlashMessageState = {
  flashMessages: [],
};

const flashMessageReducer = (
  state = initialState,
  action: FlashMessageActionTypes,
): FlashMessageState => {
  switch (action.type) {
    case ADD_FLASH_MESSAGE: {
      const { payload } = action;

      const flashMessage = {
        id: parseInt(`${new Date().getTime()}${state.flashMessages.length}`, 10),
        ...payload,
        isRemained: payload.isRemained || false, // defaultでfalseを渡し、数秒でflashMessageが消えるよう対応
      };

      const flashMessages = [...state.flashMessages, flashMessage];

      return {
        ...state,
        flashMessages,
      };
    }

    case REMOVE_FLASH_MESSAGE: {
      const { payload } = action;

      const flashMessages = state.flashMessages.filter((flashMessage) => {
        return flashMessage.id !== payload;
      });

      return {
        ...state,
        flashMessages,
      };
    }
    default:
      return state;
  }
};

export default flashMessageReducer;
